module.exports = __webpack_public_path__ + "static/media/pending-activity-marker.3419be3c.png";